import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { BRAND } from '../constants';

interface PageHeaderProps {
    onExport: () => void;
}

// Screen header — title + subtitle (left), Export Excel (right).
export default function PageHeader({ onExport }: PageHeaderProps) {
    return (
        <div style={{
            display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
            gap: 16, flexWrap: 'wrap', marginBottom: 16,
        }}>
            <div>
                <div style={{ fontSize: 18, fontWeight: 800, color: BRAND.ink, lineHeight: 1.2 }}>
                    Transacting Users
                </div>
                <div style={{ fontSize: 12, color: '#7c8b91', marginTop: 3 }}>
                    Live overview of active users and outstanding balances
                </div>
            </div>
            <Button
                icon={<DownloadOutlined style={{ fontSize: 15 }} />}
                onClick={onExport}
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6,
                    height: 38,
                    paddingInline: 20,
                    borderRadius: 999,
                    border: '1px solid #cfe2e2',
                    fontWeight: 700,
                    fontSize: 13,
                    background: BRAND.tealSoft,
                    color: BRAND.tealDark,
                    boxShadow: '0 1px 0 rgba(0, 0, 0, 0.03)',
                    transition: 'all 0.3s ease',
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#dcefef';
                    e.currentTarget.style.borderColor = '#b6d5d5';
                    e.currentTarget.style.color = BRAND.tealDeep;
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.background = BRAND.tealSoft;
                    e.currentTarget.style.borderColor = '#cfe2e2';
                    e.currentTarget.style.color = BRAND.tealDark;
                }}
            >
                Export Excel
            </Button>
        </div>
    );
}
